import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import Logo from "../../assets/images/logo.webp";
import MainButton from "../common/buttons/mainButton/MainButton";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// import { requestCourse } from "../../services/student.service";
import {
  errorToaster,
  successToaster,
} from "../../helpers/toasterConfiguration";
import environment from "../../environment";
import { Link, useNavigate } from "react-router-dom";
import { ActivityStatus } from "../../enums/activityStatus";
import { applyActivity } from "../../services/activities.service";
import {
  setActivityId,
  setRefreshActivities,
} from "../../store/slices/activitySlice";
import { activityRegistrationStatus } from "../../enums/activityRegistrationStatus";
import { ModalStyles } from "./modalStyles";

const Activity = ({ data }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAr = i18n.language === "ar";

  const [show, setShow] = useState(false);
  const [showReadMoreModal, setShowReadMoreModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [enableJoin, setEnableJoin] = useState(false);
  const _token = environment.TOKEN_KEY;
  const isLoggedIn = localStorage.getItem(_token);

  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const settings = useSelector((state) => state.setting);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseReadMoreModal = () => setShowReadMoreModal(false);
  const handleShowReadMoreModal = () => setShowReadMoreModal(true);

  const request = async (id) => {
    setIsLoading(true);
    const response = await applyActivity(id);
    if (response?.status === 200) {
      setIsLoading(false);
      successToaster(
        Resource?.request_done ? Resource?.request_done : t("request_done")
      );
      dispatch(setRefreshActivities(true));
    } else {
      setIsLoading(false);
    }
  };

  const checkWithin15MinutesBeforeSessionStart = (sessionTime) => {
    const now = new Date().getTime();
    const dateString = sessionTime;
    const [day, month, year] = dateString.split("/");
    const formattedDate = `${month}/${day}/${year}`;
    const realDate = new Date(formattedDate).getTime();
    const fifteenMinutesBeforeStartTime =
      realDate - settings?.settings?.JoinWorkshopPeriod * 60 * 1000;
    return (
      now >= fifteenMinutesBeforeStartTime && data?.status == ActivityStatus.New
    );
  };

  const checkWithin30MinutesBeforeSessionStart = (sessionTime) => {
    const now = new Date().getTime();
    const dateString = sessionTime;
    const [day, month, year] = dateString.split("/");
    const formattedDate = `${month}/${day}/${year}`;
    const realDate = new Date(formattedDate).getTime();

    const fifteenMinutesBeforeStartTime =
      realDate - (settings?.settings?.JoinWorkshopPeriod + 15) * 60 * 1000;
    return (
      now >= fifteenMinutesBeforeStartTime && data?.status == ActivityStatus.New
    );
  };

  useEffect(() => {
    const now = new Date().getTime();
    const dateString = data?.stringWorkshopDate;
    const [day, month, year] = dateString.split("/");
    const formattedDate = `${month}/${day}/${year}`;
    const realDate = new Date(formattedDate).getTime();
    if (
      checkWithin30MinutesBeforeSessionStart(data?.stringWorkshopDate) &&
      data?.status == ActivityStatus.New &&
      data?.registrationStatus == activityRegistrationStatus?.Approved &&
      !enableJoin
    ) {
      const enableButtonsTimer = setTimeout(() => {
        setEnableJoin(true);
      }, realDate - settings?.settings?.JoinWorkshopPeriod * 60 * 1000 - now);
      return () => clearTimeout(enableButtonsTimer);
    }
  }, [data, settings]);

  useEffect(() => {
    if (
      checkWithin15MinutesBeforeSessionStart(data?.stringWorkshopDate) &&
      data?.status == ActivityStatus.New &&
      data?.registrationStatus == activityRegistrationStatus?.Approved
    ) {
      setEnableJoin(true);
    }
  }, [data, settings]);

  // if (
  //   checkWithin30MinutesBeforeSessionStart(
  //     item?.sessionTime,
  //     item?.sessionEndTime
  //   ) &&
  //   !checkWithin15MinutesBeforeSessionStart(
  //     item?.sessionTime,
  //     item?.sessionEndTime
  //   )
  // )

  return (
    <Styles>
      <div className="activity">
        <div className="activity-img">
          <img src={data?.image} alt="activity image" />
        </div>
        <div className="activity-data">
          <div className="activity-title">
            {/* {Resource?.lecture ? Resource?.lecture : t("activities.lecture")} :{" "} */}
            {data?.localizedName}
          </div>
          <div className="activity-info">
            <div>
              <div className="trainer-name">
                {Resource?.engineer
                  ? Resource?.engineer
                  : t("activities.engineer")}{" "}
                : {data?.tutorName}
              </div>
              <div className="date">
                {data?.stringWorkshopDate}
                {/* {new Date(data?.stringWorkshopDate)
                  .toLocaleDateString(isAr ? "ar" : "en-UK", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })
                  .replace(/\//g, "/")}{" "}
                {new Date(data?.stringWorkshopDate).toLocaleTimeString(
                  isAr ? "ar" : "en-UK",
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  }
                )} */}
              </div>
              <div className="activity-address">
                {Resource?.place ? Resource?.place : t("activities.place")}:{" "}
                {data?.location}
              </div>
              <div className="description-container">
                <div className="activity-description">
                  {data?.localizedDescription?.length > 65 ? (
                    <>
                      {data?.localizedDescription?.substr(0, 65) + "..."}
                      <label
                        onClick={handleShowReadMoreModal}
                        className="read-more"
                      >
                        {t("read_more")}
                      </label>
                    </>
                  ) : (
                    data?.localizedDescription
                  )}
                </div>
              </div>
            </div>
            {/* <div className="activity-btns">
              <button
                className="show"
                onClick={handleShow}
                aria-label="read more"
              >
                <i className="fa fa-eye"></i>
              </button>
              <a href={data?.shareLink || "#"} target="_blank">
                <svg
                  id="send_2"
                  dataname="send 2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.514"
                  height="13.476"
                  viewBox="0 0 13.514 13.476"
                >
                  <path
                    id="Vector"
                    d="M13,.027,5.641,7.417a1.577,1.577,0,0,0-.265-.122L.515,5.65a.68.68,0,0,1,0-1.319L12.575.041A.768.768,0,0,1,12.82,0,.571.571,0,0,1,13,.027Z"
                    transform="translate(0 0)"
                    fill="#84829a"
                  />
                  <path
                    id="Vector-2"
                    dataname="Vector"
                    d="M7.39.428,3.1,12.5a.68.68,0,0,1-.68.462.68.68,0,0,1-.68-.476L.122,7.628A1.577,1.577,0,0,0,0,7.363L7.4,0A.68.68,0,0,1,7.39.428Z"
                    transform="translate(6.083 0.51)"
                    fill="#84829a"
                  />
                </svg>
              </a>
            </div> */}
          </div>
          <div className="activity-details">
            {isLoggedIn ? (
              enableJoin ? (
                <MainButton
                  buttonClick={() => {
                    navigate(`/join-v2/activity/${data?.id}`);
                  }}
                  buttonText={
                    isLoading ? (
                      <Spinner size="sm" />
                    ) : Resource?.join ? (
                      Resource?.join
                    ) : (
                      t("join")
                    )
                  }
                  buttonDisabled={isLoading}
                />
              ) : data?.status === ActivityStatus.New ? (
                !data?.registrationStatus ? (
                  <MainButton
                    buttonClick={() => {
                      request(data?.id);
                    }}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.enroll ? (
                        Resource?.enroll
                      ) : (
                        t("enroll")
                      )
                    }
                    buttonDisabled={isLoading}
                  />
                ) : data?.registrationStatus ==
                  activityRegistrationStatus?.Approved ? (
                  <div className="note">{t("activity_registered")}</div>
                ) : data?.registrationStatus ==
                  activityRegistrationStatus?.Pending ? (
                  <div className="note">{t("pending_confirm")}</div>
                ) : data?.registrationStatus ==
                  activityRegistrationStatus?.Rejected ? (
                  <MainButton
                    buttonClick={() => {
                      request(data?.id);
                    }}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.enroll ? (
                        Resource?.enroll
                      ) : (
                        t("enroll")
                      )
                    }
                    buttonDisabled={isLoading}
                  />
                ) : null
              ) : data?.status === ActivityStatus.Started ? (
                data?.registrationStatus ==
                activityRegistrationStatus?.Approved ? (
                  <MainButton
                    buttonClick={() => {
                      navigate(`/join-v2/activity/${data?.id}`);
                    }}
                    // buttonDisabled={
                    //   !checkWithin15MinutesBeforeSessionStart(
                    //     data?.stringWorkshopDate
                    //   )
                    // }
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.join ? (
                        Resource?.join
                      ) : (
                        t("join")
                      )
                    }
                    buttonDisabled={isLoading}
                  />
                ) : (
                  <MainButton
                    buttonClick={() => {
                      request(data?.id);
                    }}
                    buttonDisabled={true}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.enroll ? (
                        Resource?.enroll
                      ) : (
                        t("enroll")
                      )
                    }
                  />
                )
              ) : data?.status === ActivityStatus.Completed ? (
                <div className="note">{t("activity_done")}</div>
              ) : (
                <MainButton
                  buttonClick={() => {
                    request(data?.id);
                  }}
                  buttonDisabled={true}
                  buttonText={
                    isLoading ? (
                      <Spinner size="sm" />
                    ) : Resource?.enroll ? (
                      Resource?.enroll
                    ) : (
                      t("enroll")
                    )
                  }
                />
              )
            ) : (
              <MainButton
                buttonClick={() => {
                  handleShow();
                }}
                buttonText={
                  isLoading ? (
                    <Spinner size="sm" />
                  ) : Resource?.enroll ? (
                    Resource?.enroll
                  ) : (
                    t("enroll")
                  )
                }
              />
            )}
            <div className="count">
              {Resource?.registered
                ? Resource?.registered
                : t("activities.registered")}{" "}
              {data?.registeredStudentsCount}{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.647"
                height="18.647"
                viewBox="0 0 18.647 18.647"
              >
                <g id="Group" transform="translate(0 0)">
                  <g id="Group-2" dataname="Group">
                    <g id="Group-3" dataname="Group">
                      <path
                        id="Vector"
                        d="M18.336.622H16.472V10.878a.311.311,0,0,1-.311.311H11.81v7.148a.311.311,0,0,1-.311.311H3.419a.311.311,0,0,1-.311-.311V.622H.311A.311.311,0,0,1,.311,0H18.336a.311.311,0,0,1,0,.622Zm-11.81,0H5.283v2.8a.311.311,0,0,0,.311.311h.622a.311.311,0,0,0,.311-.311ZM7.77,10.878V.622H7.148v2.8a.932.932,0,0,1-.932.932H5.594a.932.932,0,0,1-.932-.932V.622H3.729v17.4h7.459V11.188H8.08A.311.311,0,0,1,7.77,10.878ZM15.85.622H8.391v9.945H15.85Z"
                        transform="translate(18.647 18.647) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-2"
                        dataname="Vector"
                        d="M2.176,2.486H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0H2.176a.311.311,0,0,1,.311.311V2.176A.311.311,0,0,1,2.176,2.486ZM1.865.622H.622V1.865H1.865Z"
                        transform="translate(10.877 6.837) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-3"
                        dataname="Vector"
                        d="M2.176,2.486H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0H2.176a.311.311,0,0,1,.311.311V2.176A.311.311,0,0,1,2.176,2.486ZM1.865.622H.622V1.865H1.865Z"
                        transform="translate(10.877 3.729) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-4"
                        dataname="Vector"
                        d="M2.176,2.486H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0H2.176a.311.311,0,0,1,.311.311V2.176A.311.311,0,0,1,2.176,2.486ZM1.865.622H.622V1.865H1.865Z"
                        transform="translate(13.985 6.837) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-5"
                        dataname="Vector"
                        d="M2.176,2.486H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0H2.176a.311.311,0,0,1,.311.311V2.176A.311.311,0,0,1,2.176,2.486ZM1.865.622H.622V1.865H1.865Z"
                        transform="translate(13.985 3.729) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-6"
                        dataname="Vector"
                        d="M2.176,2.486H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0H2.176a.311.311,0,0,1,.311.311V2.176A.311.311,0,0,1,2.176,2.486ZM1.865.622H.622V1.865H1.865Z"
                        transform="translate(13.985 9.945) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-7"
                        dataname="Vector"
                        d="M2.176,2.486H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0H2.176a.311.311,0,0,1,.311.311V2.176A.311.311,0,0,1,2.176,2.486ZM1.865.622H.622V1.865H1.865Z"
                        transform="translate(13.985 13.053) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-8"
                        dataname="Vector"
                        d="M.311,0H2.176a.311.311,0,0,1,.311.311V2.176a.311.311,0,0,1-.311.311H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0ZM.622,1.865H1.865V.622H.622Z"
                        transform="translate(6.216 14.296) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-9"
                        dataname="Vector"
                        d="M.311,0H2.176a.311.311,0,0,1,.311.311V2.176a.311.311,0,0,1-.311.311H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0ZM.622,1.865H1.865V.622H.622Z"
                        transform="translate(6.216 11.188) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-10"
                        dataname="Vector"
                        d="M.311,0H2.176a.311.311,0,0,1,.311.311V2.176a.311.311,0,0,1-.311.311H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0ZM.622,1.865H1.865V.622H.622Z"
                        transform="translate(6.216 17.404) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-11"
                        dataname="Vector"
                        d="M.311,0H2.176a.311.311,0,0,1,.311.311V2.176a.311.311,0,0,1-.311.311H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0ZM.622,1.865H1.865V.622H.622Z"
                        transform="translate(9.324 14.296) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-12"
                        dataname="Vector"
                        d="M.311,0H2.176a.311.311,0,0,1,.311.311V2.176a.311.311,0,0,1-.311.311H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0ZM.622,1.865H1.865V.622H.622Z"
                        transform="translate(9.324 11.188) rotate(180)"
                        fill="#84829a"
                      />
                      <path
                        id="Vector-13"
                        dataname="Vector"
                        d="M.311,0H2.176a.311.311,0,0,1,.311.311V2.176a.311.311,0,0,1-.311.311H.311A.311.311,0,0,1,0,2.176V.311A.311.311,0,0,1,.311,0ZM.622,1.865H1.865V.622H.622Z"
                        transform="translate(9.324 17.404) rotate(180)"
                        fill="#84829a"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <ModalStyles show={showReadMoreModal} onHide={handleCloseReadMoreModal}>
        <Modal.Body style={isAr ? { direction: "rtl" } : { direction: "ltr" }}>
          <Modal.Header closeButton></Modal.Header>
          <div className="modal-main-img">
            <img src={data?.image} alt="logo" />
          </div>
          <div className="activity-data">
            <div className="activity-title">
              {/* {Resource?.lecture ? Resource?.lecture : t("activities.lecture")}{" "} */}
              {/* : */}
              {data?.localizedName}
            </div>
            <div className="activity-info">
              <div>
                <div className="trainer-name">
                  {Resource?.engineer
                    ? Resource?.engineer
                    : t("activities.engineer")}{" "}
                  : {data?.tutorName}
                </div>
                <div className="date">
                  {data?.stringWorkshopDate}
                  {/* {new Date(data?.stringWorkshopDate)
                    .toLocaleDateString(isAr ? "ar" : "en-UK", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\//g, "/")}{" "}
                  {new Date(data?.stringWorkshopDate).toLocaleTimeString(
                    isAr ? "ar" : "en-UK",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    }
                  )} */}
                </div>
                <div className="activity-address">
                  {Resource?.place ? Resource?.place : t("activities.place")}:{" "}
                  {data?.location}
                </div>
                <div className="description-container">
                  <div className="activity-description">
                    {data?.localizedDescription}
                  </div>
                </div>
              </div>
            </div>
            {isLoggedIn ? (
              <div className="modal-buttons">
                {enableJoin ? (
                  <MainButton
                    buttonClick={() => {
                      navigate(`/join-v2/activity/${data?.id}`);
                    }}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.join ? (
                        Resource?.join
                      ) : (
                        t("join")
                      )
                    }
                    buttonDisabled={isLoading}
                  />
                ) : data?.status === ActivityStatus.New ? (
                  !data?.registrationStatus ? (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                      buttonDisabled={isLoading}
                    />
                  ) : data?.registrationStatus ==
                    activityRegistrationStatus?.Approved ? (
                    <div className="note">{t("activity_registered")}</div>
                  ) : data?.registrationStatus ==
                    activityRegistrationStatus?.Pending ? (
                    <div className="note">{t("pending_confirm")}</div>
                  ) : data?.registrationStatus ==
                    activityRegistrationStatus?.Rejected ? (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                      buttonDisabled={isLoading}
                    />
                  ) : null
                ) : data?.status === ActivityStatus.Started ? (
                  data?.registrationStatus ==
                  activityRegistrationStatus?.Approved ? (
                    <MainButton
                      buttonClick={() => {
                        navigate(`/join-v2/activity/${data?.id}`);
                      }}
                      // buttonDisabled={
                      //   !checkWithin15MinutesBeforeSessionStart(
                      //     data?.stringWorkshopDate
                      //   )
                      // }
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.join ? (
                          Resource?.join
                        ) : (
                          t("join")
                        )
                      }
                      buttonDisabled={isLoading}
                    />
                  ) : (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonDisabled={true}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                    />
                  )
                ) : data?.status === ActivityStatus.Completed ? (
                  <div className="note">{t("activity_done")}</div>
                ) : (
                  <MainButton
                    buttonClick={() => {
                      request(data?.id);
                    }}
                    buttonDisabled={true}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.enroll ? (
                        Resource?.enroll
                      ) : (
                        t("enroll")
                      )
                    }
                  />
                )}
                {/* {data?.status === ActivityStatus.New ? (
                  data?.registrationStatus == null ? (
                    <div className="note">{t("activity_registered")}</div>
                  ) : (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                    />
                  )
                ) : data?.status === ActivityStatus.Started ? (
                  data?.isUserRegistered ? (
                    <MainButton
                      // buttonClick={() => {
                      //   request(slug);
                      // }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.join ? (
                          Resource?.join
                        ) : (
                          t("join")
                        )
                      }
                    />
                  ) : (
                    <MainButton
                      // buttonClick={() => {
                      //   request(slug);
                      // }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                      buttonDisabled={true}
                    />
                  )
                ) : (
                  data?.status === ActivityStatus.Completed && (
                    <div className="note">{t("activity_done")}</div>
                  )
                )} */}
              </div>
            ) : data?.status === ActivityStatus.Completed ? (
              <div className="note">{t("activity_done")}</div>
            ) : (
              <div className="modal-buttons">
                <MainButton
                  buttonClick={() => {
                    handleCloseReadMoreModal();
                    handleShow();
                  }}
                  buttonText={
                    isLoading ? (
                      <Spinner size="sm" />
                    ) : Resource?.enroll ? (
                      Resource?.enroll
                    ) : (
                      t("enroll")
                    )
                  }
                />
              </div>
            )}
          </div>
        </Modal.Body>
      </ModalStyles>
      <ModalStyles show={show} onHide={handleClose}>
        {isLoggedIn ? (
          <Modal.Body
            style={isAr ? { direction: "rtl" } : { direction: "ltr" }}
          >
            <Modal.Header closeButton></Modal.Header>
            <div className="modal-main-img">
              <img src={data?.image} alt="logo" />
            </div>
            <div className="activity-data">
              <div className="activity-title">
                {Resource?.lecture
                  ? Resource?.lecture
                  : t("activities.lecture")}{" "}
                : {data?.localizedName}
              </div>
              <div className="activity-info">
                <div>
                  <div className="trainer-name">
                    {Resource?.engineer
                      ? Resource?.engineer
                      : t("activities.engineer")}{" "}
                    : {data?.tutorName}
                  </div>
                  <div className="activity-address">
                    {Resource?.place ? Resource?.place : t("activities.place")}:{" "}
                    {data?.location}
                  </div>
                  <div className="description-container">
                    <div className="activity-description">
                      {data?.localizedDescription}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-buttons">
                {enableJoin ? (
                  <MainButton
                    buttonClick={() => {
                      navigate(`/join-v2/activity/${data?.id}`);
                    }}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.join ? (
                        Resource?.join
                      ) : (
                        t("join")
                      )
                    }
                  />
                ) : data?.status === ActivityStatus.New ? (
                  !data?.registrationStatus ? (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                    />
                  ) : data?.registrationStatus ==
                    activityRegistrationStatus?.Approved ? (
                    <div className="note">{t("activity_registered")}</div>
                  ) : data?.registrationStatus ==
                    activityRegistrationStatus?.Pending ? (
                    <div className="note">{t("pending_confirm")}</div>
                  ) : data?.registrationStatus ==
                    activityRegistrationStatus?.Rejected ? (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                    />
                  ) : null
                ) : data?.status === ActivityStatus.Started ? (
                  data?.registrationStatus ==
                  activityRegistrationStatus?.Approved ? (
                    <MainButton
                      buttonClick={() => {
                        navigate(`/join-v2/activity/${data?.id}`);
                      }}
                      // buttonDisabled={
                      //   !checkWithin15MinutesBeforeSessionStart(
                      //     data?.stringWorkshopDate
                      //   )
                      // }
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.join ? (
                          Resource?.join
                        ) : (
                          t("join")
                        )
                      }
                    />
                  ) : (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonDisabled={true}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                    />
                  )
                ) : data?.status === ActivityStatus.Completed ? (
                  <div className="note">{t("activity_done")}</div>
                ) : (
                  <MainButton
                    buttonClick={() => {
                      request(data?.id);
                    }}
                    buttonDisabled={true}
                    buttonText={
                      isLoading ? (
                        <Spinner size="sm" />
                      ) : Resource?.enroll ? (
                        Resource?.enroll
                      ) : (
                        t("enroll")
                      )
                    }
                  />
                )}
                {/* {data?.status === ActivityStatus.New ? (
                  data?.registrationStatus == null ? (
                    <div className="note">{t("activity_registered")}</div>
                  ) : (
                    <MainButton
                      buttonClick={() => {
                        request(data?.id);
                      }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                    />
                  )
                ) : data?.status === ActivityStatus.Started ? (
                  data?.isUserRegistered ? (
                    <MainButton
                      // buttonClick={() => {
                      //   request(slug);
                      // }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.join ? (
                          Resource?.join
                        ) : (
                          t("join")
                        )
                      }
                    />
                  ) : (
                    <MainButton
                      // buttonClick={() => {
                      //   request(slug);
                      // }}
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.enroll ? (
                          Resource?.enroll
                        ) : (
                          t("enroll")
                        )
                      }
                      buttonDisabled={true}
                    />
                  )
                ) : (
                  data?.status === ActivityStatus.Completed && (
                    <div className="note">{t("activity_done")}</div>
                  )
                )} */}
              </div>
            </div>
          </Modal.Body>
        ) : data?.status === ActivityStatus.Completed ? (
          <div className="note">{t("activity_done")}</div>
        ) : (
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <div className="modal-img">
              <img src={Logo} alt="logo" />
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 100.543 100.543"
              className="mb-3"
            >
              <g
                id="Iconly_Light_Danger-Circle"
                dataname="Iconly/Light/Danger-Circle"
                transform="translate(-0.25 -0.25)"
              >
                <g id="Danger-Circle" transform="translate(2.75 2.75)">
                  <path
                    id="Stroke-1"
                    d="M48.522.75A47.771,47.771,0,1,1,.75,48.522,47.772,47.772,0,0,1,48.522.75Z"
                    transform="translate(-0.75 -0.75)"
                    fill="none"
                    stroke="#90359c"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="5"
                    fillRule="evenodd"
                  />
                  <line
                    id="Stroke-3"
                    y2="22.822"
                    transform="translate(47.746 28.168)"
                    fill="none"
                    stroke="#90359c"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="5"
                  />
                  <line
                    id="Stroke-5"
                    x2="0.052"
                    transform="translate(47.745 67.376)"
                    fill="none"
                    stroke="#90359c"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="5"
                  />
                </g>
              </g>
            </svg>
            <div className="title">
              {Resource?.please_login
                ? Resource?.please_login
                : t("course_details.form.title_with_nologin")}
            </div>
            <div className="description">
              {Resource?.add_oppinion_form_description
                ? Resource?.add_oppinion_form_description
                : t("course_details.form.description")}
            </div>
            <Link to={`/login`}>
              <MainButton
                buttonText={
                  Resource?.login ? Resource?.login : t("navbar.log_in")
                }
              />
            </Link>
          </Modal.Body>
        )}
      </ModalStyles>
    </Styles>
  );
};

export default Activity;
